import Vue from 'vue';
import { VIEW_DETECTS, VIEW_FIELD, VIEW_TRACKS } from '@/constants';
/* global toString:Boolean */
const toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is a Boolean
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
function isBoolean(val) {
  return typeof val === 'boolean';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if an object is a DOM element
 *
 * @param {Object} obj The object to test
 * @returns {boolean} True if object is an instance of the HTMLElement type
 */
function isDOMElement(obj) {
  return (
    typeof HTMLElement === "object"
    ? obj instanceof HTMLElement //DOM2
    : !!obj && typeof obj === "object" && obj !== null && obj.nodeType === 1 && typeof obj.nodeName==="string"
  );
}

/**
 * Calculate left and top offsets of an element inside the page
 *
 * @param {HTMLElement} el The DOM element
 * @returns {Object} {x: offsetLeft, y: offsetTop}
 */
function getOffset(el) {
  var res = {
    x: el['offsetLeft'],
    y: el['offsetTop'],
  };
  var parent = el.offsetParent;

  while (!!parent) {
    res.x += parent['offsetLeft'];
    res.y += parent['offsetTop'];
    parent = parent.offsetParent;
  }

  return res;
}

export function getDurationFormat(duration, isHour = false) {
  const format = isHour ? 'HH:mm:ss' : 'mm:ss';
  return Vue.moment(duration*1000).utc().format(format);
}

export function getObjectKeyByValue(object, value) {
  return Object.keys(object).find(key => object[key] === value);
}

export function isReadyVideo(statuses, type) {
  if (!statuses) {
    return false;
  }

  switch (type) {
    case VIEW_DETECTS:
      return statuses.detect;
    case VIEW_FIELD:
      return statuses.field;
    case VIEW_TRACKS:
      return statuses.track;
    default:
      return true;
  }
}

export function sortNumbers(a, b) {
  if (a === 0) return 1;
  if (b === 0) return -1;
  return a - b;
}

export default {
  isArray,
  isFormData,
  isString,
  isNumber,
  isBoolean,
  isUndefined,
  isObject,
  isDate,
  isFile,
  isBlob,
  isFunction,
  isDOMElement,
  getOffset,
};
